'use client';

import { c as _c } from "react/compiler-runtime";
import type { WebMainPageResponse } from '@module/apis/client-side/main/type';
import { LiveRefresh } from '@module/svg/icons';
import getMainListAdjustSize from '@pc/utils/main/getMainListAdjustSize';
import MainBroadcastSection, { type MainSectionProps } from './MainBroadcastSection';
interface Props extends MainSectionProps {
  data?: WebMainPageResponse;
  onRefresh: () => void;
}
function LiveRecommendContainer(t0) {
  const $ = _c(14);
  const {
    data,
    isLoading,
    isFetching,
    isFetched,
    currentScreenSize,
    listLength,
    onRefresh
  } = t0;
  let t1;
  if ($[0] !== currentScreenSize || $[1] !== data || $[2] !== listLength) {
    t1 = data?.recommend ? getMainListAdjustSize({
      list: data.recommend,
      currentScreenSize,
      listLength
    }) ?? [] : undefined;
    $[0] = currentScreenSize;
    $[1] = data;
    $[2] = listLength;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const bjList = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LiveRefresh style={{
      fontSize: 3.5
    }} />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onRefresh) {
    t3 = <div className="mt-[6px] cursor-pointer" onClick={onRefresh}>{t2}</div>;
    $[5] = onRefresh;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== bjList || $[8] !== isFetched || $[9] !== isFetching || $[10] !== isLoading || $[11] !== listLength || $[12] !== t3) {
    t4 = <MainBroadcastSection dataTestId="main-recommended" title={"\uCD94\uCC9C \uB77C\uC774\uBE0C\uBC29\uC1A1"} list={bjList} isLoading={isLoading} isFetching={isFetching} isFetched={isFetched} listLength={listLength} titleAction={t3} />;
    $[7] = bjList;
    $[8] = isFetched;
    $[9] = isFetching;
    $[10] = isLoading;
    $[11] = listLength;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
export default LiveRecommendContainer;